/*
 * Novicell master
 * Author: APN modified by DLA
 * Use this file to call functions in other files, on document ready, window.resize etc.
 * ------
 * Dependencies: jquery, novicell.js, other files with awesome functions.
 * Usage: $(function () {
 *            LokalDN.slider.heroSlider($('.owl-carousel'));
 *        }); // Document ready end
 */

var novicell = novicell || {};
var dnDepartments = dnDepartments || {};

// Document ready
$(function () {
    // Third party
    svg4everybody(); // Fix SVG spritemap in IE/Edge

    // Novicell scripts
    //novicell.responsive.init();
    novicell.responsiveLazyloadImage.image();
    novicell.embed.loadEmbeds();

    // localDN scripts
    dnDepartments.navigation.init();
    //dnDepartments.responsiveImages.init();
    dnDepartments.pageHeaderImage.init();
    dnDepartments.imageSlider.init();
    dnDepartments.stickyMenu.init();

    // Sharelinks
    dnDepartments.shareLinks.trigger();

    novicell.map.init();

}); // Document ready end

// Window resize
$(window).smartresize(function (e) {
    // call functions here
    novicell.responsiveLazyloadImage.onResize();
    novicell.embed.onResize();
    dnDepartments.navigation.moveNavigationElements();
}); // Window resize


$(window).load(function () {
    dnDepartments.socialMedia.facebook.init();
});

$(window).resize(function () {
}).resize();

$(window).scroll(function () {
    novicell.responsiveLazyloadImage.scroll();
});